(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["t2m-manuals"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('t2m-manuals')) {
    customElements.define('t2m-manuals', class extends HTMLElement {
      connectedCallback() {
        if (this.manualsController) return;
        this.manualsController = new AbortController();
        const options = { signal: this.manualsController.signal };
        const cards = Array.from(this.querySelectorAll('[data-manual-card]'));
        const groups = Array.from(this.querySelectorAll('[data-manual-group]'));
        const search = this.querySelector('[data-search]');
        const category = this.querySelector('[data-category]');
        const count = this.querySelector('[data-result-count]');
        const empty = this.querySelector('[data-no-results]');
        const controls = this.querySelector('[data-controls]');
        if (!search || !category || !count || !empty || !controls) return;
        const normalize = value => String(value || '').normalize('NFKD').replace(/[\u0300-\u036f]/g, '').toLowerCase().trim();
        const indexed = cards.map(card => ({ card, text: normalize(card.dataset.keywords) }));
        this.querySelector('[data-search-field]').hidden = cards.length < 4;
        this.querySelector('[data-category-field]').hidden = groups.length < 2;
        controls.hidden = cards.length < 4 && groups.length < 2;
        const filter = () => {
          const words = normalize(search.value).split(/\s+/).filter(Boolean);
          let visible = 0;
          indexed.forEach(({ card, text }) => {
            const matchesCategory = category.value === 'all' || card.dataset.category === category.value;
            card.hidden = !(matchesCategory && words.every(word => text.includes(word)));
            if (!card.hidden) visible += 1;
          });
          groups.forEach(group => { group.hidden = !Array.from(group.querySelectorAll('[data-manual-card]')).some(card => !card.hidden); });
          count.textContent = `${visible} ${visible === 1 ? 'manual' : 'manuals'}`;
          empty.hidden = visible > 0;
        };
        const reveal = () => {
          let key;
          try { key = decodeURIComponent(location.hash.slice(1)); } catch { return; }
          const card = cards.find(item => item.id === key);
          if (!card) return;
          search.value = '';
          category.value = 'all';
          filter();
          requestAnimationFrame(() => card.scrollIntoView({ block: 'start', behavior: 'auto' }));
        };
        search.addEventListener('input', filter, options);
        category.addEventListener('change', filter, options);
        window.addEventListener('hashchange', reveal, options);
        document.addEventListener('shopify:block:select', event => {
          if (!this.contains(event.target)) return;
          search.value = '';
          category.value = 'all';
          filter();
        }, options);
        filter();
        if (location.hash) reveal();
      }
      disconnectedCallback() {
        if (this.manualsController) this.manualsController.abort();
        this.manualsController = null;
      }
    });
  }

  } catch(e) { console.error(e); }
})();
})();
